import React, { useState, useEffect } from "react";

import NuxeoClient from "../../clients/NuxeoClient";
import Autocomplete from "../ui/Autocomplete";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";

import { useI18n } from "../../I18nProvider";

export default function SubmissionType(props) {
  const appText = useI18n();
  const [fetchedData, setFetchedData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    _loadSubmissionTypes();
  }, []);

  async function _loadSubmissionTypes() {
    await NuxeoClient.instance()
      .fetchSubmissionTypes()
      .then((response) => {
        setFetchedData(response);
        setIsLoading(false);
      });
  }

  const handleChange = (value) => {
    props.handleChange("submissionType", value.label);
  };

  return (
    // <Tooltip arrow title="Select the submission type here">
    <Tooltip arrow title={appText.T404}>
      <Grid item={true} xs={12}>
        <div id="contract">
          <InputLabel className="field-label field-dropdown" required>
            {appText.T344}
          </InputLabel>
          <Autocomplete
            type={"single"}
            handleChange={handleChange}
            data={fetchedData}
            dataType={"submissionType"}
            mapVariable={"label"}
            setFilterData={() => null}
            value={props.value}
            isLoading={isLoading}
          />
        </div>
      </Grid>
    </Tooltip>
  );
}
